import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import styles from "./toast.module.scss";

const VARIANTS = {
	Info: {
		base: "toast--info",
		nameKey: "toast.info",
	},

	Error: {
		base: "toast--error",
		nameKey: "toast.error",
	},

	Warning: {
		base: "toast--warning",
		nameKey: "toast.warning",
	},

	Success: {
		base: "toast--success",
		nameKey: "toast.success",
	},
} as const;

type ToastMessageProps = {
	id: string;
	header: string;
	message: string;
	lifetime: number;
	onRemove: any;
	type: string;
	icon: string;
};

const ToastMessage: FC<ToastMessageProps> = ({
	id,
	header,
	message,
	lifetime,
	onRemove,
	type,
}) => {
	const { t } = useTranslation("layout");
	const variant = type ? VARIANTS[type as keyof typeof VARIANTS] : null;
	const Var = variant
		? { base: variant.base, name: t(variant.nameKey) }
		: { base: "", name: header };

	useEffect(() => {
		if (lifetime && onRemove) {
			setTimeout(() => {
				onRemove(id);
			}, lifetime);
		}
	}, [lifetime]);

	return (
		<div className={`${styles["toast"]} ${styles[Var.base]}`}>
			<div className={`${styles["toast__inner"]}`}>
				<div className={`${styles["toast__message-container"]}`}>
					<h4 data-cy="toast-title" className={`${styles["toast__heading"]}`}>
						{header ? header : Var.name}
					</h4>

					{message && (
						<p className={`${styles["toast__message"]}`}>{message}</p>
					)}
				</div>
				<div
					onClick={() => onRemove && onRemove(id)}
					className={`${styles["toast__close"]}`}
				/>
			</div>
		</div>
	);
};

export { ToastMessage };
